










import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { JinroGameDocument } from "@/services/datatypes";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import { SNACKBAR_DURATION_MILLISECONDS } from "@/services/constants";

@Component({
  components: {}
})
export default class JinroGameNotification extends Vue {
  @Prop() readonly jinroGameId!: string;
  alreadyShownSnackbarMessage = "";

  get gameMasterMessage(): string {
    if (this.jinroGame) {
      return this.jinroGame.gmMessage;
    }
    return "";
  }

  @Watch("jinroGameId")
  onChange() {
    this.showGmTemporaryMessageViaSnackbar();
  }

  get jinroGame(): JinroGameDocument | null {
    if (!this.$store.state.jinroGame) {
      return null;
    }

    return this.$store.state.jinroGame;
  }

  showGmTemporaryMessageViaSnackbar(): void {
    if (!this.jinroGame) {
      return;
    }
    const tms = this.jinroGame.gmTemporaryMessage;
    if (tms === "") {
      return;
    }

    if (tms !== this.alreadyShownSnackbarMessage) {
      Snackbar.open({
        duration: SNACKBAR_DURATION_MILLISECONDS,
        position: "is-top",
        queue: false,
        actionText: null,
        message: tms
      });
      this.alreadyShownSnackbarMessage = tms;
    }
  }
}
